export default __webpack_public_path__ + "images/988c97b69f9f17dfa9ef2c917416f2c4-3_web_1919x543.jpg";